import { ArrowRight, Clock } from "lucide-react";
import { Chapter, Reveal, scrollToId } from "@/components/Reveal";
import { MEETING_IMG, OFFICE_IMG } from "@/data/content";

const SESSIONS = [
  {
    title: "HR Consultancy",
    desc: "Hiring plans, policy, payroll, retention — bring your toughest people problem.",
    img: MEETING_IMG,
    testid: "book-hr-consultancy",
  },
  {
    title: "Business Consultancy",
    desc: "Registration, tax, compliance, Startup India — get your foundations right.",
    img: OFFICE_IMG,
    testid: "book-business-consultancy",
  },
];

export default function Appointments() {
  return (
    <section className="py-24 md:py-32 border-t border-white/10" data-testid="appointments-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Chapter num="Chapter 04" label="Free Consultation" />
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight font-medium text-white max-w-2xl">
            Book a free appointment. One hour. No strings.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SESSIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.15}>
              <button
                onClick={() => scrollToId("#contact")}
                className="group relative block w-full text-left overflow-hidden border border-white/10 aspect-[16/10]"
                data-testid={s.testid}
              >
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-zinc-950/70 group-hover:bg-zinc-950/55 transition-colors duration-500" />
                <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
                  <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary font-semibold mb-3">
                    <Clock className="w-3.5 h-3.5" /> 1 hr · Free
                  </span>
                  <h3 className="font-heading text-3xl md:text-4xl font-medium text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-zinc-300 text-sm md:text-base max-w-md">
                    {s.desc}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:text-primary transition-colors duration-300">
                    Book Now
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
